"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[865],{

/***/ 80865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgEficienciaEnergeticaCircle = function SvgEficienciaEnergeticaCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18.917 8.535h-5.834A2.083 2.083 0 0 0 11 10.618v9.167a2.083 2.083 0 0 0 2.083 2.083h.417v1.225a.417.417 0 1 0 .833 0v-1.225h3.334v1.225a.417.417 0 1 0 .833 0v-1.225h.417A2.083 2.083 0 0 0 21 19.785v-9.167a2.083 2.083 0 0 0-2.083-2.083Zm-5.417 12.5V17.7h5v3.334h-5Zm6.667-1.25a1.25 1.25 0 0 1-.834 1.173v-3.673a.417.417 0 0 0-.416-.417h-5.834a.417.417 0 0 0-.416.417v3.673a1.25 1.25 0 0 1-.834-1.173v-9.167a1.25 1.25 0 0 1 1.25-1.25h5.834a1.25 1.25 0 0 1 1.25 1.25v9.167Z",
    fill: "CurrentColor"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16 18.118a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm0 1.667a.417.417 0 1 1 0-.835.417.417 0 0 1 0 .835ZM16.27 10.3a.417.417 0 0 0-.54 0c-.23.194-2.23 1.929-2.23 3.235a2.5 2.5 0 0 0 5 0c0-1.306-2-3.041-2.23-3.235ZM16 15.201a1.666 1.666 0 0 1-1.667-1.666c0-.618.934-1.684 1.667-2.36.733.675 1.667 1.741 1.667 2.36A1.667 1.667 0 0 1 16 15.2Z",
    fill: "CurrentColor"
  })), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.5,
    y: 0.535,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#765346"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgEficienciaEnergeticaCircle);

/***/ })

}]);